import React, { useState } from "react";
import remove from "lodash/remove";

import { SummerSchoolSparkContext } from "../contexts/summerSchoolSparkContext";
import { useEventListener } from "../hooks/useEventListener";
import { EVENT_TOPICS } from "../utilities/eventUtils";

const SummerSchoolSparkProvider = ({ children }) => {
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState();
  const [totalPages, setTotalPages] = useState();
  const [applicants, setApplicants] = useState();
  const [applicant, setApplicant] = useState();
  const [allApplicants, setAllApplicants] = useState();

  useEventListener(
    EVENT_TOPICS.ON_APPLICANT_DELETED,
    ({ deletedApplicantId }) => {
      const copiedData = [...applicants];
      remove(copiedData, (item) => item.id === deletedApplicantId);

      setApplicants(copiedData);
    },
    [applicants]
  );

  useEventListener(
    EVENT_TOPICS.ON_APPLICANT_UPDATED,
    ({ response }) => {
      setApplicant(response);
    },
    [applicant]
  );

  return (
    <SummerSchoolSparkContext.Provider
      value={{
        applicant,
        setApplicant,
        applicants,
        setApplicants,
        allApplicants,
        setAllApplicants,
        currentPage,
        setCurrentPage,
        totalPages,
        setTotalPages,
        totalRecords,
        setTotalRecords,
        pageSize,
        setPageSize,
      }}
    >
      {children}
    </SummerSchoolSparkContext.Provider>
  );
};

export default SummerSchoolSparkProvider;
